module.exports = __webpack_public_path__ + "img/sad-face.9d07976d.svg";